import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  constructor() {
    console.log('AuthLayoutComponent constructor');
  }

  ngOnInit(): void {
    console.log('AuthLayoutComponent ngOnInit');
  }

  ngOnDestroy(): void {
    console.log('AuthLayoutComponent ngOnDestroy');
  }
}
